// copied from VPC
import { style, types } from 'typestyle';
import { CommonStyles } from '../../../common/styles/CommonStyles';

const cssPrefix = 'PageHeader';

export namespace PageHeaderStyles {
  export const ButtonFocus: React.CSSProperties = CommonStyles.Focus.Indicator;

  export const FavoriteButtonFocusClass = cssClass(cssPrefix, 'favorite-button-focus', {
    $nest: {
      '&:focus': {
        ...ButtonFocus,
      },
    },
  });
}

export type Style = types.NestedCSSProperties;

export function cssClass(prefix: string, name: string, ...styles: Style[]): string {
  return style(...styles, {
    $debugName: `${prefix}_${name}`,
    $unique: true,
  });
}
